import React, { createContext, useContext, useState, useCallback } from 'react';

const SupportWidgetContext = createContext(null);

export function SupportWidgetProvider({ children }) {
  const [emailWidgetOpen, setEmailWidgetOpen] = useState(false);
  const [emailWidgetMinimized, setEmailWidgetMinimized] = useState(false);

  const openEmailWidget = useCallback(() => {
    setEmailWidgetMinimized(false);
    setEmailWidgetOpen(true);
  }, []);

  const closeEmailWidget = useCallback(() => {
    setEmailWidgetOpen(false);
    setEmailWidgetMinimized(false);
  }, []);

  const minimizeEmailWidget = useCallback(() => {
    setEmailWidgetMinimized(true);
  }, []);

  const restoreEmailWidget = useCallback(() => {
    setEmailWidgetMinimized(false);
  }, []);

  return (
    <SupportWidgetContext.Provider
      value={{
        emailWidgetOpen,
        emailWidgetMinimized,
        openEmailWidget,
        closeEmailWidget,
        minimizeEmailWidget,
        restoreEmailWidget
      }}
    >
      {children}
    </SupportWidgetContext.Provider>
  );
}

export function useSupportWidget() {
  const ctx = useContext(SupportWidgetContext);
  if (!ctx) {
    throw new Error('useSupportWidget must be used within SupportWidgetProvider');
  }
  return ctx;
}

export default SupportWidgetContext;
